var map = {
	"./404.svg": 961,
	"./Categories.png": 962,
	"./Edit-menu.svg": 963,
	"./Egg.svg": 964,
	"./Emaier-Header.png": 965,
	"./Qr-4.png": 966,
	"./_duplicate.svg": 967,
	"./_overview.svg": 968,
	"./add-white.svg": 969,
	"./alert.svg": 970,
	"./all_category.svg": 971,
	"./archive.svg": 972,
	"./armchair.svg": 973,
	"./arrow-circle-right.svg": 974,
	"./arrow-left-circle.svg": 975,
	"./arrow-right-circle.svg": 976,
	"./arrow-right.svg": 977,
	"./asc-up-white.svg": 978,
	"./asc.png": 979,
	"./asc.svg": 980,
	"./back-arrow.svg": 981,
	"./barcode-icon.svg": 982,
	"./beverages.svg": 983,
	"./blue-edit-pen.svg": 984,
	"./blue-eye.svg": 985,
	"./box-office.svg": 986,
	"./broken-seat.jpg": 987,
	"./calendar_list.svg": 988,
	"./calender.svg": 372,
	"./chevron-down.svg": 989,
	"./chevron-left.svg": 990,
	"./cinema-mamagement-sidebar.svg": 991,
	"./claendar.svg": 320,
	"./clock-1.svg": 992,
	"./clock.svg": 993,
	"./close-button.svg": 727,
	"./close-white.svg": 729,
	"./close-x.svg": 315,
	"./collapse-up.svg": 994,
	"./collapse.svg": 995,
	"./connection-lost.svg": 370,
	"./consumable-raw-material.svg": 996,
	"./copy.svg": 997,
	"./copy_image_icon.png": 998,
	"./delete-red-light.svg": 999,
	"./delete-red.svg": 736,
	"./delete.svg": 710,
	"./deliver-icon.svg": 1000,
	"./desc-down-white.svg": 1001,
	"./desc.svg": 1002,
	"./distributors-sidebar.svg": 1003,
	"./download.svg": 1004,
	"./dragndrop.svg": 1005,
	"./dragndrop2.svg": 1006,
	"./duplicate.svg": 1007,
	"./duplicateScreen.svg": 1008,
	"./e-wallet-icon-black.svg": 1009,
	"./edit-pen-blue.svg": 1010,
	"./edit-pen-white.svg": 1011,
	"./edit-pen.svg": 1012,
	"./edit.svg": 1013,
	"./email.png": 1014,
	"./empty-image.svg": 1015,
	"./excel.svg": 1016,
	"./external-link.svg": 1017,
	"./eye.svg": 1018,
	"./filter-icon.svg": 1019,
	"./flag.svg": 1020,
	"./fnb-app-order.svg": 1021,
	"./fnb-beverages.svg": 1022,
	"./fnb-brownie.svg": 1023,
	"./fnb-combo.svg": 1024,
	"./fnb-desert.svg": 1025,
	"./fnb-eatables.svg": 1026,
	"./fnb-make-your-combo.svg": 1027,
	"./fnb-popcorn.svg": 1028,
	"./fnbtransactionIcon.svg": 1029,
	"./fullscreen-icon.svg": 737,
	"./funnel.svg": 1030,
	"./globe.svg": 1031,
	"./green-tick.svg": 1032,
	"./grid-view.svg": 1033,
	"./hide-password.svg": 373,
	"./home-icon.svg": 1034,
	"./home.svg": 1035,
	"./icon-black-play.svg": 1036,
	"./icon-dot.svg": 1037,
	"./icon-fnb.svg": 1038,
	"./icon-marketing.svg": 1039,
	"./icon-no-seat.png": 1040,
	"./icon-no-seat.svg": 1041,
	"./icon-option.svg": 1042,
	"./icon-poin-of-sale.svg": 1043,
	"./icon-recliner.svg": 1044,
	"./icon-report.svg": 1045,
	"./icon-sofa-dark-1.svg": 1046,
	"./icon-sofa-dark.png": 1047,
	"./icon-sofa-dark.svg": 1048,
	"./icon-sofa.svg": 1049,
	"./importfile.svg": 1050,
	"./info.svg": 730,
	"./info2.svg": 1051,
	"./keyboard-icon.svg": 1052,
	"./kitchen_display.svg": 1053,
	"./language-icon.svg": 374,
	"./left-caret.svg": 1054,
	"./link.svg": 1055,
	"./list-view.svg": 1056,
	"./loading.svg": 375,
	"./lock.svg": 1057,
	"./login-password.png": 376,
	"./login-user.png": 377,
	"./logout.svg": 731,
	"./masters-sidebar.svg": 1058,
	"./merchandise.svg": 1059,
	"./minus.svg": 1060,
	"./movie-pass-svg.svg": 719,
	"./movie-rolling.svg": 1061,
	"./mulitSchedule.svg": 1062,
	"./multicurrency.svg": 1063,
	"./multifnb.svg": 1064,
	"./nav-plus.svg": 1065,
	"./new_filter_icon.svg": 1066,
	"./no-image.svg": 1067,
	"./no-schedule.svg": 145,
	"./non-veg-mark.png": 1068,
	"./non-veg-mark.svg": 1069,
	"./notification.svg": 1070,
	"./open-link-blue.svg": 1071,
	"./openPlanned.svg": 1072,
	"./overview.svg": 1073,
	"./overview2.svg": 1074,
	"./pdf-icon.svg": 1075,
	"./pdf.svg": 1076,
	"./pickup-ticket-icon.svg": 1077,
	"./pickupfnb.svg": 1078,
	"./play.svg": 1079,
	"./plus.svg": 1080,
	"./pointofsale-1.svg": 1081,
	"./pointofsale-2.svg": 1082,
	"./pointofsale.png": 1083,
	"./portfolio.svg": 1084,
	"./pos-fnb-no-itmes.svg": 723,
	"./pos-refresh.svg": 1085,
	"./primary/chevron-down.svg": 1086,
	"./primary/download.svg": 1087,
	"./primary/edit.svg": 1088,
	"./primary/filter.svg": 1089,
	"./primary/printer.svg": 1090,
	"./print-icon.svg": 1091,
	"./print.svg": 1092,
	"./question.svg": 1093,
	"./question1.svg": 1094,
	"./question2.svg": 738,
	"./question3.svg": 1095,
	"./recliner-1.svg": 1096,
	"./recliner.png": 1097,
	"./refund-icon.svg": 1098,
	"./reload-icon-pos.svg": 1099,
	"./reload-icon.svg": 1100,
	"./restore.svg": 1101,
	"./right-caret.svg": 1102,
	"./role-management-sidebar.svg": 1103,
	"./save.svg": 1104,
	"./schedule-icon.svg": 1105,
	"./school-calendar.svg": 1106,
	"./search-global-white.svg": 1107,
	"./search-global.svg": 1108,
	"./search.svg": 1109,
	"./searchIcon.svg": 1110,
	"./seat-icon-2.svg": 1111,
	"./seat-icon.svg": 1112,
	"./seat-icons/3-wheelChair.png": 1113,
	"./seat-icons/block_seat_new.png": 1114,
	"./seat-icons/broken-seat-1.svg": 1115,
	"./seat-icons/broken-seat-2.svg": 1116,
	"./select-food.png": 739,
	"./settings.svg": 1117,
	"./show-password.svg": 378,
	"./slider-triangle.svg": 732,
	"./snack.svg": 733,
	"./sort.svg": 1118,
	"./star-empty.svg": 1119,
	"./star-fill.svg": 1120,
	"./success-tick.svg": 1121,
	"./suitcase.svg": 1122,
	"./swap.svg": 1123,
	"./tick-green-item.svg": 740,
	"./tick-green.svg": 1124,
	"./ticket-icon.svg": 1125,
	"./trash.svg": 1126,
	"./unpaid-reservation.svg": 715,
	"./updown-white.svg": 1127,
	"./updown.svg": 1128,
	"./user-attribute.svg": 1129,
	"./user-attributes.svg": 1130,
	"./user-female.svg": 1131,
	"./user-male-white.svg": 1132,
	"./user-male.svg": 1133,
	"./user-profile.svg": 1134,
	"./userProfile.png": 1135,
	"./veg-food-mark-white.png": 1136,
	"./veg-foog-mark-trans.png": 1137,
	"./view.png": 1138,
	"./view.svg": 1139
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 960;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 960
// module chunks = 37